import useMutation from "src/hooks/useMutation";

function useWTUpdate(id) {
  const path = id
    ? `/api/v1/warehouse-transfers/${id}`
    : `/api/v1/warehouse-transfers/id`;
  return useMutation({
    path: path,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTUpdate;
